import { Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { MODAL_SIZES } from 'config/modaSettings';
import { useEditFormStore } from 'stores/local';

const SaveModal: React.FC = () => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  return (
    <Modal
      width={MODAL_SIZES.s}
      onCancel={editFormStore.saveModal.close}
      open={editFormStore.saveModal.opened}
      title={t('editForm.saveModalNotice')}
      cancelText={t('editForm.saveAnyway')}
      okText={t('common.cancel')}
      onOk={editFormStore.saveModal.close}
      cancelButtonProps={{
        loading: editFormStore.formStore.formUpdateRequest.loading,
        onClick: editFormStore.updateForm,
      }}
      centered
    >
      <Typography.Text>{t('editForm.saveModalContent')}</Typography.Text>
    </Modal>
  );
};

export default observer(SaveModal);
